import { useCallback, useMemo } from 'react';
import { useRouter } from './useRouter';

export interface UsePaginationSearchParams {
  scrollToTopOnChange?: boolean;
}

export const usePaginationSearch = (params?: UsePaginationSearchParams) => {
  const { scrollToTopOnChange = true } = params ?? {};

  const { infoFromCurrentPath, setCurrentSearch } = useRouter();

  const currentPage = useMemo(() => {
    const searchPage = infoFromCurrentPath.search.page;
    if (searchPage && Number(searchPage) > 0) {
      return Number(searchPage) - 1;
    }
    return 0;
  }, [infoFromCurrentPath.search.page]);

  const handlePaginationChange = useCallback(
    (changedPage: number) => {
      setCurrentSearch({ ...infoFromCurrentPath.search, page: changedPage + 1 });
      if (scrollToTopOnChange) {
        window?.scrollTo(0, 0);
      }
    },
    [infoFromCurrentPath.search, scrollToTopOnChange, setCurrentSearch],
  );

  return { currentPage, handlePaginationChange };
};
